import React from 'react'
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

// selectors
import { useTranslation } from 'react-i18next'

import picture404 from '../../assets/404picture.svg';

function Error404() {
  const { t } = useTranslation();

  return (
    <Box
      style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '504px', gap: '35px', margin: '0 auto', marginTop: '48px' }}
    >
      <img
        src={picture404}
        alt="Woman reading"
        style={{
            alignSelf: 'flex-start',
            width: '122px',
            height: '121px'
          }}
      />
      <Typography
        variant="body1"
        style={{
            fontFamily: 'Johnson Text',
            fontSize: '32px',
            lineHeight: '120%',
            letterSpacing: '0%',
          }}
      >
        <span style={{ fontWieght: 'bold', display: 'block' }}>404.</span>
        {t('error-404')}
      </Typography>
      <Link
        to="/"
        style={{
            textDecoration: 'none',
            padding: '12px 24px',
            background: '#312C2A',
            borderRadius: '9999px',
            width: '85px',
            fontFamily: 'Johnson Text',
            fontSize: '16px',
            lineHeight: '150%',
            color: 'white'
          }}
      >
        {t('error-go-to-home')}
      </Link>
    </Box>
  )
}

export default Error404
